import axios from "axios";

export const getUsersSettings = (word, role, organizationId) => {
  const fields = [
    "id",
    "firstName",
    "lastName",
    "avatar",
    "role",
    "accountingAuthorization"
  ];

  let roleGroup = "1";
  if (role && role !== "ALL") {
    roleGroup = role.slice(0, 1);
    role = role.slice(1);
  }

  let requestUrl = `${
    roleGroup === "2"
      ? "/organization/user"
      : "/authorization/apps-authorization"
  }`;
  let filter = [];

  if (roleGroup === "2") {
    filter.push({
      property: "role.type",
      value: role,
      operator: "eq"
    });
    filter.push({
      property: "role.organization",
      value: organizationId,
      operator: "eq"
    });
  } else {
    if (role && role !== "ALL") {
      requestUrl += "?appRole=" + role;
    }
  }
  if (word !== "" && word.length >= 3) {
    filter.push({
      property: "name",
      value: escape(word.trim()),
      operator: "like"
    });
  }

  let params = {
    filter: JSON.stringify(filter),
    fields: fields.join(","),
    limit: 100,
    organization_id: organizationId,
    app: "ACCOUNTING"
  };

  return axios.get(requestUrl, {
    params
  });
};

export const saveUsersSettings = (
  role,
  activateNotifications,
  activateCarteNotifications,
  activateCalendarNotifications,
  /**
   * @deprecated
   */
  allowAccessClientSpace,
  allowConfigurateBudget,
  allowUpdatingBillingView,
  allowUpdatingTarifClients,
  allowUpdatingNewClients,
  allowUpdatingDepartClients,
  allowAccessToClientCollaboratorRelation,
  allowAccessToClientInformations,
  allowAccessToGlobalBudget,
  allowUpdatingOffrePrice,
  allowToAddDeleger,
  allowUpdateBudgetedBenchmark,
  allowAccessToStatisticsCards,
  allowAccessToCorrectionCards,
  allowVisualizationOfBudgetedTime,
  allowVisualizationOfBudgetedBenchmark,
  allowVisualizationOfRealizedTime,
  allowVisualizationOfRealizedBenchmark,
  allowAdjustDistributionOfTasksByRole,
  allowAttributionBU,
  allowAttributionSquad,
  allowCollabToDevCard,
  allowAttributionCluster,
  allowSelectAppliedModel,
  allowTodragAndDropFromTODO,
  allowTodragAndDropFromWIP,
  allowTodragAndDropFromDONE,
  allowTodragAndDropFromVALIDATION,
  allowAccessToClientList,
  allowCreateCorrectionCards,
  allowAccessToCollaboratorList,
  allowAccessReporting,
  allowAccessReportingTab,
  allowAccessProductionCapacity,
  allowAccessBonusPlan,
  allowAccessEcheance,
  allowAccessBalanceRecap,
  allowAccessCalendar,
  allowAccessTimeReport,
  allowAccessPortfolio,
  allowAccessErrReporting,
  allowAccessVacationMatrix,
  allowAccessPlans,
  allowAccessPrestation,
  allowAccessPrestaTS,
  allowAccessFinancial,
  allowAccessFinancialSheet,
  allowAccessForfait,
  allowAccessCroissance,
  allowAccessDynamicTable,
  allowAccessCapacityPlanning,
  allowAccessCapacityPlanningTab,
  allowAccessSynthesis,
  allowAccessSetting,
  allowAccessCategorySetting,
  allowAccessTaskTypeSetting,
  allowAccessCollaboratorSetting,
  allowAccessCalendarSetting,
  allowCoefficientsConfig,
  allowAccessModelSetting,
  allowAccessUserSetting,
  allowAccessSynchronization,
  allowAccessParameterSetting,
  /**
   * Use this instead
   */
  dashboardPreferences,
  clientsPreferences,
  collaboratorsPreferences,
  prestationsPreferences,
  financialPreferences,
  reportingPreferences,
  capacityPlanningPreferences,
  settingsPreferences,
  timesheetPreferences,
  notificationPreferences,
  usersIds,
  clientId
) => {
  const requestUrl = `/authorization/multi-save`;
  var formData = new FormData();
  for (let userId of usersIds) {
    formData.append("users_id[]", userId);
  }
  formData.append("client_id", clientId);
  formData.append("role", role);
  formData.append("preferences[allowAccess]", 1);

  formData.append(
    "preferences[dashboard]",
    JSON.stringify(dashboardPreferences)
  );
  formData.append("preferences[clients]", JSON.stringify(clientsPreferences));
  formData.append(
    "preferences[collaborators]",
    JSON.stringify(collaboratorsPreferences)
  );
  formData.append(
    "preferences[financial]",
    JSON.stringify(financialPreferences)
  );
  formData.append(
    "preferences[prestations]",
    JSON.stringify(prestationsPreferences)
  );
  formData.append(
    "preferences[reporting]",
    JSON.stringify(reportingPreferences)
  );
  formData.append(
    "preferences[capacityPlanning]",
    JSON.stringify(capacityPlanningPreferences)
  );
  formData.append("preferences[settings]", JSON.stringify(settingsPreferences));
  formData.append(
    "preferences[timesheet]",
    JSON.stringify(timesheetPreferences)
  );
  formData.append(
    "preferences[notifications]",
    JSON.stringify(notificationPreferences)
  );
  formData.append(
    "preferences[allowAccessToStatisticsCards]",
    Number(allowAccessToStatisticsCards)
  );
  formData.append(
    "preferences[allowAccessToCorrectionCards]",
    Number(allowAccessToCorrectionCards)
  );
  formData.append(
    "preferences[allowAccessClientSpace]",
    Number(allowAccessClientSpace)
  );
  formData.append(
    "preferences[allowAccessToClientCollaboratorRelation]",
    Number(allowAccessToClientCollaboratorRelation)
  );
  formData.append(
    "preferences[allowConfigurateBudget]",
    Number(allowConfigurateBudget)
  );

  formData.append(
    "preferences[allowAccessToClientInformations]",
    Number(allowAccessToClientInformations)
  );
  formData.append(
    "preferences[allowAccessToGlobalBudget]",
    Number(allowAccessToGlobalBudget)
  );

  formData.append(
    "preferences[allowVisualizationOfBudgetedTime]",
    Number(allowVisualizationOfBudgetedTime)
  );
  formData.append(
    "preferences[allowVisualizationOfBudgetedBenchmark]",
    Number(allowVisualizationOfBudgetedBenchmark)
  );
  formData.append(
    "preferences[allowVisualizationOfRealizedTime]",
    Number(allowVisualizationOfRealizedTime)
  );
  formData.append(
    "preferences[allowVisualizationOfRealizedBenchmark]",
    Number(allowVisualizationOfRealizedBenchmark)
  );

  formData.append(
    "preferences[allowUpdatingOffrePrice]",
    Number(allowUpdatingOffrePrice)
  );
  formData.append("preferences[allowToAddDeleger]", Number(allowToAddDeleger));
  formData.append(
    "preferences[allowUpdateBudgetedBenchmark]",
    Number(allowUpdateBudgetedBenchmark)
  );

  formData.append(
    "preferences[allowUpdatingBillingView]",
    Number(allowUpdatingBillingView)
  );
  formData.append(
    "preferences[allowUpdatingTarifClients]",
    Number(allowUpdatingTarifClients)
  );
  formData.append(
    "preferences[allowUpdatingNewClients]",
    Number(allowUpdatingNewClients)
  );
  formData.append(
    "preferences[allowUpdatingDepartClients]",
    Number(allowUpdatingDepartClients)
  );

  formData.append(
    "preferences[allowAdjustDistributionOfTasksByRole]",
    Number(allowAdjustDistributionOfTasksByRole)
  );
  formData.append(
    "preferences[allowAttributionBU]",
    Number(allowAttributionBU)
  );
  formData.append(
    "preferences[allowAttributionSquad]",
    Number(allowAttributionSquad)
  );
  formData.append(
    "preferences[allowCollabToDevCard]",
    Number(allowCollabToDevCard)
  );
  formData.append(
    "preferences[allowAttributionCluster]",
    Number(allowAttributionCluster)
  );
  formData.append(
    "preferences[allowSelectAppliedModel]",
    Number(allowSelectAppliedModel)
  );
  formData.append(
    "preferences[allowTodragAndDropFromTODO]",
    Number(allowTodragAndDropFromTODO)
  );
  formData.append(
    "preferences[allowTodragAndDropFromWIP]",
    Number(allowTodragAndDropFromWIP)
  );
  formData.append(
    "preferences[allowTodragAndDropFromDONE]",
    Number(allowTodragAndDropFromDONE)
  );
  formData.append(
    "preferences[allowTodragAndDropFromVALIDATION]",
    Number(allowTodragAndDropFromVALIDATION)
  );

  formData.append(
    "preferences[activateNotifications]",
    Number(activateNotifications)
  );
  formData.append(
    "preferences[activateCalendarNotifications]",
    Number(activateCalendarNotifications)
  );
  formData.append(
    "preferences[activateCarteNotifications]",
    Number(activateCarteNotifications)
  );
  formData.append(
    "preferences[allowAccessToClientList]",
    Number(allowAccessToClientList)
  );
  formData.append(
    "preferences[allowAccessToCollaboratorList]",
    Number(allowAccessToCollaboratorList)
  );
  formData.append(
    "preferences[allowCreateCorrectionCards]",
    Number(allowCreateCorrectionCards)
  );

  formData.append(
    "preferences[allowAccessReporting]",
    Number(allowAccessReporting)
  );
  formData.append(
    "preferences[allowAccessReportingTab]",
    Number(allowAccessReportingTab)
  );
  formData.append(
    "preferences[allowAccessProductionCapacity]",
    Number(allowAccessProductionCapacity)
  );
  formData.append(
    "preferences[allowAccessBonusPlan]",
    Number(allowAccessBonusPlan)
  );
  formData.append(
    "preferences[allowAccessEcheance]",
    Number(allowAccessEcheance)
  );
  formData.append(
    "preferences[allowAccessBalanceRecap]",
    Number(allowAccessBalanceRecap)
  );
  formData.append(
    "preferences[allowAccessCalendar]",
    Number(allowAccessCalendar)
  );
  formData.append(
    "preferences[allowAccessTimeReport]",
    Number(allowAccessTimeReport)
  );
  formData.append(
    "preferences[allowAccessPortfolio]",
    Number(allowAccessPortfolio)
  );
  formData.append(
    "preferences[allowAccessErrReporting]",
    Number(allowAccessErrReporting)
  );
  formData.append(
    "preferences[allowAccessVacationMatrix]",
    Number(allowAccessVacationMatrix)
  );
  formData.append("preferences[allowAccessPlans]", Number(allowAccessPlans));
  formData.append(
    "preferences[allowAccessPrestation]",
    Number(allowAccessPrestation)
  );

  formData.append(
    "preferences[allowAccessPrestaTS]",
    Number(allowAccessPrestaTS)
  );
  formData.append(
    "preferences[allowAccessFinancial]",
    Number(allowAccessFinancial)
  );
  formData.append(
    "preferences[allowAccessFinancialSheet]",
    Number(allowAccessFinancialSheet)
  );
  formData.append(
    "preferences[allowAccessForfait]",
    Number(allowAccessForfait)
  );
  formData.append(
    "preferences[allowAccessCroissance]",
    Number(allowAccessCroissance)
  );
  formData.append(
    "preferences[allowAccessDynamicTab]",
    Number(allowAccessDynamicTable)
  );
  formData.append(
    "preferences[allowAccessCapacityPlanning]",
    Number(allowAccessCapacityPlanning)
  );
  formData.append(
    "preferences[allowAccessCapacityPlanningTab]",
    Number(allowAccessCapacityPlanningTab)
  );
  formData.append(
    "preferences[allowAccessSynthesis]",
    Number(allowAccessSynthesis)
  );

  formData.append(
    "preferences[allowAccessSetting]",
    Number(allowAccessSetting)
  );
  formData.append(
    "preferences[allowAccessCategorySetting]",
    Number(allowAccessCategorySetting)
  );
  formData.append(
    "preferences[allowAccessTaskTypeSetting]",
    Number(allowAccessTaskTypeSetting)
  );
  formData.append(
    "preferences[allowAccessCollaboratorSetting]",
    Number(allowAccessCollaboratorSetting)
  );
  formData.append(
    "preferences[allowAccessCalendarSetting]",
    Number(allowAccessCalendarSetting)
  );
  formData.append(
    "preferences[allowCoefficientsConfig]",
    Number(allowCoefficientsConfig)
  );
  formData.append(
    "preferences[allowAccessModelSetting]",
    Number(allowAccessModelSetting)
  );
  formData.append(
    "preferences[allowAccessUserSetting]",
    Number(allowAccessUserSetting)
  );
  formData.append(
    "preferences[allowAccessSynchronization]",
    Number(allowAccessSynchronization)
  );
  formData.append(
    "preferences[allowAccessParameterSetting]",
    Number(allowAccessParameterSetting)
  );

  formData.append("application", "ACCOUNTING");
  return axios.post(requestUrl, formData);
};

export const deleteUsersSettings = (usersIds, clientId) => {
  const requestUrl = `/authorization/multi-delete`;

  var formData = new FormData();
  for (let userId of usersIds) {
    formData.append("users_id[]", userId);
  }
  formData.append("client_id", clientId);
  formData.append("application", "ACCOUNTING");

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/authorizations.js